import styled from 'styled-components'

const getColor = (props) => {
  if (props.isDragAccept) {
    return props.theme.colors.success
  }
  if (props.isDragReject) {
    return props.theme.colors.error
  }
  if (props.isDragActive) {
    return props.theme.colors.primary
  }
  return props.theme.colors.lightGray
}

export const Container = styled.div`
  font-family: 'Roboto';
  flex-wrap: nowrap;
  flex-direction: column;
  align-self: center;
  align-items: center;
  justify-content: center;
  margin: 16px 16px 16px;
  border-width: 1px;
  border-radius: 12px;
  border-color: ${(props) => getColor(props)};
  border-style: dashed;
  background-color: ${({ theme }) => theme.colors['neutral-color-0']};
  outline: none;
  transition: border 0.24s ease-in-out;
  display: flex;
  width: 100%;

  &:not(:disabled):hover {
    border-color: ${({ theme }) => theme.colors['brand-color-primary-0']};
    cursor: pointer;
  }
`

export const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  gap: ${({ theme }) => theme.spacing[4]};
  margin-top: ${({ theme }) => theme.spacing[12]};
  height: 100%;
`

export const LoadingContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: ${({ theme }) => theme.spacing[4]};
  margin-top: ${({ theme }) => theme.spacing[12]};
  height: 100%;
  width: 100%;
`

export const SpinningContainer = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  align-items: center;
  justify-content: center;
`

export const LoadingBarContainer = styled.div`
  margin-top: auto;
  margin-bottom: ${({ theme }) => theme.spacing[16]};
  padding: ${({ theme }) => theme.spacing[16]};
  width: 100%;
`
